<template>
	<input
		class="rp-single-otp-input"
		:class="inputClasses"
		type="text"
		min="0"
		max="9"
		pattern="[0-9]*"
		inputmode="numeric"
		ref="input"
		v-model="model"
		@input="handleOnChange"
		@keydown="handleOnKeyDown"
		@paste="handleOnPaste"
		@focus="handleOnFocus"
		@blur="handleOnBlur"
		:disabled="disabled"
	/>
</template>

<script>
export default {
	name: "InputField",
	props: {
		value: {
			type: String
		},

		separator: {
			type: String
		},

		focus: {
			type: Boolean
		},

		inputClasses: {
			type: String
		},

		shouldAutoFocus: {
			type: Boolean
		},

		isInputNum: {
			type: Boolean
		},

		isLastChild: {
			type: Boolean
		},

		disabled: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			model: this.value || ""
		};
	},
	mounted() {
		if (this.$refs.input && this.focus && this.shouldAutoFocus) {
			this.$refs.input.focus();
		}
	},

	watch: {
		value(newValue, oldValue) {
			if (newValue !== oldValue) {
				this.model = newValue;
			}
		},
		// whenever question changes, this function will run
		focus(newFocusValue, oldFocusValue) {
		// Check if focusedInput changed
		// Prevent calling function if input already in focus
			if (oldFocusValue !== newFocusValue && this.$refs.input && this.focus) {
				this.$refs.input.focus();
				this.$refs.input.select();
			}
		}
	},
	methods: {
		handleOnChange() {
			if (this.model.length > 1) {
				this.model = this.model.slice(0, 1);
			}
			return this.$emit("on-change", this.model);
		},

		handleOnKeyDown(event) {
			return this.$emit("on-keydown", event);
		},

		handleOnPaste(event) {
			return this.$emit("on-paste", event);
		},

		handleOnFocus() {
			this.$refs.input.select();
			return this.$emit("on-focus");
		},

		handleOnBlur() {
			return this.$emit("on-blur");
		}
	}
};
</script>
<style lang="scss">
.rp-single-otp-input {
	margin-right: 0.6rem;
	border: 1px solid #ccc;
	border-radius: 4px;
	height: 50px;
	width: 40px;
	text-align: center;
	color: #333333;
	font-size: 1rem;
	outline: none;
	&:last-child{
		margin-right: 0rem; 
	}
}
</style>